import { Map, List } from 'immutable';

import Services from '../records/Services';
import Fare from '../records/Fare';
import BaseStore from './BaseStore';
import { resolve, resolveAll } from '../helpers/LinkMapper';
import { ActionTypes } from '../constants/AppConstants';


function _toJson (search) {
    return JSON.stringify(search.serialize());
}

const defaultState = new Map({
    services: new Services(),
    fares: new List(),
    loading: false
});

class JourneyStore extends BaseStore {

    deserialize (serialized) {
        if (serialized) {
            return new Map({
                searchJsonString: serialized.searchJsonString,
                services: resolve(serialized.services).as(Services),
                fares: resolveAll(serialized.fares).as(Fare),
                loading: false
            });
        }

        return defaultState;
    }

    getJourneys () {
        return this.state.get('journeys', new Map());
    }

    getJourney () {
        return this.state;
    }

    isCurrentSearch (search) {
        if (search.promoCode && search.promoCode.promoCode) { // prevent applying the same promo code twice
            return false;
        }
        return _toJson(search) === this.state.get('searchJsonString');
    }

    handleSearchStarted ({ search }) {
        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            loading: true
        }));
    }

    handleSearchFinished ({ outward, inward, search }) {
        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            services: (new Services({outward, inward})).orderForSearch(search),
            loading: false
        }));
    }

    handleFareOnlySearchFinished ({ search, fares }) {
        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            fares,
            loading: false
        }));
    }

    handleSearchUpdated ({ result, search }) {
        this.setState(this.state.merge({
            searchJsonString: _toJson(search),
            services: (new Services({
                outward: result.outward,
                inward: result.inward
            })).orderForSearch(search),
            loading: false
        }));
    }

    resetJourneyStore () {
        this.setState(defaultState);
    }

    getActionHandlers () {
        return {
            [ ActionTypes.SEARCH_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.SEARCH_FINISHED ]: this.handleSearchFinished,
            [ ActionTypes.FARE_ONLY_SEARCH_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.FARE_ONLY_SEARCH_FINISHED ]: this.handleFareOnlySearchFinished,
            [ ActionTypes.SHOW_EARLIER_TRAINS_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.SHOW_EARLIER_TRAINS_FINISHED ]: this.handleSearchUpdated,
            [ ActionTypes.SHOW_LATER_TRAINS_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.SHOW_LATER_TRAINS_FINISHED ]: this.handleSearchUpdated,
            [ ActionTypes.AMEND_SEARCH_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.AMEND_SEARCH_FINISHED ]: this.handleSearchFinished,
            [ ActionTypes.AMEND_SHOW_EARLIER_TRAINS_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.AMEND_SHOW_EARLIER_TRAINS_FINISHED ]: this.handleSearchUpdated,
            [ ActionTypes.AMEND_SHOW_LATER_TRAINS_STARTED ]: this.handleSearchStarted,
            [ ActionTypes.AMEND_SHOW_LATER_TRAINS_FINISHED ]: this.handleSearchUpdated,
            [ ActionTypes.RESET_JOURNEY_STORE ]: this.resetJourneyStore,
        };
    }
}

const instance = new JourneyStore({ storageKey: 'journeys' });

export default instance;
